import Swiper from "swiper/bundle";

const ReviewsSlider = () => {
  const reviewsSliders = [...document.querySelectorAll(".reviews__slider")];

  const initializeSlider = () => {
    reviewsSliders.forEach((reviewsSlider) => {
      const pagination = reviewsSlider.querySelector(".slider__pagination");
      const btns = document.querySelector(".reviews .slider__btns");
      const nextBtn = document.querySelector(".reviews__slider-btn-next");
      const prevBtn = document.querySelector(".reviews__slider-btn-prev");

      const slides = [...reviewsSlider.querySelectorAll('.swiper-slide')];


      const minSlidesForMobile = 1;
      const minSlidesForTablet = 2;
      const minSlidesForDesktop = 3;

      const shouldInitializeSlider =  (window.innerWidth >= 1024 && slides.length > minSlidesForDesktop) ||
                                      (window.innerWidth < 1024 && window.innerWidth >= 768 && slides.length > minSlidesForTablet) ||
                                      (window.innerWidth < 768 && slides.length > minSlidesForMobile);
      

      if (!shouldInitializeSlider) {
        if (btns && pagination) {
          btns.classList.add("d-none");
          pagination.classList.add("d-none");
        }
      }

      if (shouldInitializeSlider) {
        if (btns && pagination) {
          btns.classList.remove("d-none");
          pagination.classList.remove("d-none");
        }

        const reviewsCarousel = new Swiper(reviewsSlider, {
          slidesPerView: "auto",
          spaceBetween: 16,
          // loop: true,
          pagination: {
            el: pagination,
            clickable: true,
          },
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
            1441: {
              slidesPerView: 3,
              spaceBetween: 32,
            },
          },
        });
      }
    });
  };

  initializeSlider();

  window.addEventListener('resize', () => {
    reviewsSliders.forEach((reviewsSlider) => {
      const swiperInstance = reviewsSlider.swiper;
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
      }
    });
    initializeSlider();
  });
};

export default ReviewsSlider;

